import * as AdminPrefrenceActionCreator from "./AdminPrefrenceActionCreator"


export function defaultAdminPrefrenceState() {
    return {
      isLoading: false,
      isResponse: null,
      isError: null,
    };
  }
  /**
   * User Reducer its take state and action
   * @param state
   * @param action
   */
  export const AdminprefrencesReducer = (state, action) => {
    if (
      !state ||
      action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFRENCE_STATE
    ) {
      return { ...state, ...defaultAdminPrefrenceState() };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE) {
      return { ...state, isLoading: true };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFRENCE) {
      return { ...state, isResponse: action.data, isLoading: false };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFRENCE) {
      return { ...state, isError: action.data, isLoading: false };
    }
  
    return state; 
  };


  export function defaultAdminPrefrenceListState() {
    return {
       isLoading: false,
      isResponse: null,
      isError: null,
         
    };
  }

  export const AdminPrefrenceListReducer = (state, action) => {
    if (
      !state ||
      action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFRENCE_LIST_STATE
    ) {
      return { ...state, ...defaultAdminPrefrenceListState() };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE_LIST) {
      return { ...state, isLoading: true };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFRENCE_LIST) {
      return { ...state, isResponse: action.data, isLoading: false };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFRENCE_LIST) {
      return { ...state, isError: action.data, isLoading: false };
    }
  
    return state; 
  };

  

  export function defaultAdminPrefrenceByIdState() {
    return {
       isLoading: false,
      isResponse: null,
      isError: null,
         
    };
  }

  export const AdminPrefrenceByIdReducer = (state, action) => {
    if (
      !state ||
      action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFERENCE_BY_ID_STATE
    ) {
      return { ...state, ...defaultAdminPrefrenceByIdState() };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFRENCE_BY_ID) {
      return { ...state, isLoading: true };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFRENCE_BY_ID) {
      return { ...state, isResponse: action.data, isLoading: false };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFRENCE_BY_ID) {
      return { ...state, isError: action.data, isLoading: false };
    }
  
    return state; 
  };
  

  export function defaultAdminPrefrenceEditState() {
    return {
       isLoading: false,
      isResponse: null,
      isError: null,
      
         
    };
  }

  export const AdminPrefrenceEditReducer = (state, action) => {
    if (
      !state ||
      action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESET_ADMIN_PREFERENCE_EDIT_STATE
    ) {
      return { ...state, ...defaultAdminPrefrenceEditState() };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.REQUEST_ADMIN_PREFERENCE_EDIT_STATE) {
      return { ...state, isLoading: true, isResponse: null, isError: null };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.RESPONSE_ADMIN_PREFERENCE_EDIT_STATE) {
      return { ...state, isResponse: action.data, isLoading: false };
    }
  
    if (action.type === AdminPrefrenceActionCreator.ADMIN_PREFRENCE_ACTION.ERROR_ADMIN_PREFERENCE_EDIT_STATE) {
      return { ...state, isError: action.data, isLoading: false };
    }
  
    return state; 
  };
    


        
